<template>
    <footer>
        <div class="text-primary-300 w-full py-4 text-center">
            <span v-floating-tooltip="[nodeDescription, 'top', true]"> <fa :icon="['fas', 'code-branch']" /> {{ version }} </span>
        </div>
    </footer>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';

export default defineComponent({
    setup() {
        const version = computed(() => `${window.Wisp.Node || 'unknown'} - ${window.Wisp.Version || 'unknown'}`);

        type NodeIdentifierToLocation = {
            [key: string]: string;
        };

        const nodeIdentifierMap: NodeIdentifierToLocation = {
            'us-chi': 'Chicago, United States',
            'us-nyc': 'New York, United States',
            'us-dal': 'Dallas, United States',
            'us-los': 'Los Angeles, United States',
            'uk-lon': 'London, United Kingdom',
            'eu-nur': 'Nuremberg, Germany',
            'sa-sgp': 'Singapore',
            local: 'local dev',
        };

        const node = window.Wisp.Node || 'unknown';
        const parts = node.split('-');

        const nodeLocation = parts.length >= 2 ? `${parts[0]}-${parts[1]}` : node;
        const location = nodeIdentifierMap[nodeLocation] || 'Unknown Location';

        const nodeDescription = `You are geo-routed to our web server in ${location}. We've automatically chosen this location to give you the fastest experience possible.`;

        return {
            version,
            nodeDescription,
        };
    },
});
</script>
